"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseContainsHeader = void 0;
const utils_1 = require("../../utils");
const ResponseContainsHeader = (options) => {
    const names = options.names || {};
    return {
        Operation: {
            Response: {
                enter: (response, { report, location, key }) => {
                    var _a;
                    const expectedHeaders = names[key] ||
                        names[utils_1.getMatchingStatusCodeRange(key)] ||
                        names[utils_1.getMatchingStatusCodeRange(key).toLowerCase()] ||
                        [];
                    for (const expectedHeader of expectedHeaders) {
                        if (!((_a = response.headers) === null || _a === void 0 ? void 0 : _a[expectedHeader])) {
                            report({
                                message: `Response object must contain a "${expectedHeader}" header.`,
                                location: location.child('headers').key(),
                            });
                        }
                    }
                },
            },
        },
    };
};
exports.ResponseContainsHeader = ResponseContainsHeader;
